import ReactDOM from 'react-dom'

import { getPlayerId } from './controllers/stats'
import { initialiseAnalytics } from './vendors/analytics'
import { injectAdsAndCMPScript, refreshVenatusAds, renderVenatusAds } from './vendors/venatus-ads'
import { setupConsentListener } from './vendors/consent'
import App from './App'
import checkMigration from './util/checkMigration'
import checkOverwritePlayerId from './util/checkOverwritePlayerId'
import checkPlayerMerge from './util/checkPlayerMerge'
import isSupporter from './util/isSupporter'
import logGoogleEvent from './util/logEvent'
import setupEngagementTimer from './util/setupEngagementTimer'
import { ADS_ENABLED } from './config'

async function main() {
	// Check if we've been given a player ID to use, and we are safe to just overwrite the player ID
	// that they currently have in localStorage (i.e. they've never played, and we're not on puzzlist.com).
	// We may have been given a player ID to use from Waffle, and it's helpful if they match.
	checkOverwritePlayerId()

	// Check if player has added the game to their home screen
	const isStandalone =
		window.matchMedia('(display-mode: standalone)').matches ||
		('standalone' in navigator && navigator.standalone === true)
	// Log "standalone" players to keep track of numbers
	if (isStandalone) logGoogleEvent('ows_standalone', { pid: getPlayerId() })

	// Check if we are migrating this player to puzzlist.com
	const migrate = await checkMigration().catch(e =>
		console.error('Error checking to migrate: ', e.message)
	)
	if (migrate) return

	// Check if a player ID has been provided in the query string.
	// If so, we'll need to merge the scores from that player ID with those of the current
	// player ID, and then replace the current player ID with the new one.
	// (We don't need to await this before letting them play the game)
	checkPlayerMerge().catch(e => console.error('Error with newplayer ID: ', e.message))

	// Render app
	ReactDOM.render(<App />, document.getElementById('root'))

	setupEngagementTimer()

	if (!isSupporter() && ADS_ENABLED) {
		initialiseAnalytics()
		injectAdsAndCMPScript()
		setupConsentListener()
		setTimeout(renderVenatusAds, 1000)
		window.addEventListener('resize', refreshVenatusAds)
	}
}

main()
